/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */


import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ListIngredients from "./files/ListIngredients";
import DeleteIngredient from "./files/DeleteIngredient";
import AddIngredient from "./files/AddIngredient";

const IngredientPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/list"
          element={
            <>
              <ListIngredients />
            </> 
          }
        />


         <Route
          path="/delete/:id"
          element={
            <>
              <DeleteIngredient />
            </>
          }
        />
     
       
      
        <Route index element={<Navigate to="list" />} />
      </Route>
    </Routes>
  );
};

export default IngredientPage;
